import React, { useState } from "react";
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";

interface InputFieldProps {
  type: string;
  placeholder: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  isMobile: boolean;
  required: boolean;
  accept?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  value,
  type,
  placeholder,
  onChange,
  className = "",
  isMobile,
  required,
  accept = "*",
  ...props
}) => {
  const [pwType, setPwType] = useState("password");
  const [icon, setIcon] = useState(eyeOff);

  const handleToggle = () => {
    if (pwType === "password") {
      setIcon(eye);
      setPwType("text");
    } else {
      setIcon(eyeOff);
      setPwType("password");
    }
  };

  return (
    <div className={type === "password" ? "mb-[40px]" : ""}>
      <input
        accept={accept}
        type={type === "password" ? pwType : type}
        placeholder={placeholder}
        className={
          className +
          " w-full bg-blue-950 px-3 py-2 border border-gray-500 text-gray-300 text-left rounded-sm"
        }
        value={value}
        onChange={onChange}
        required={required}
      />
      {type === "password" && (
        <span
          className={
            (isMobile ? "-mr-[265px] " : "-mr-[335px] ") +
            "flex justify-around -mt-[63px]  items-center"
          }
          onClick={handleToggle}
        >
          <Icon className="absolute text-gray-500" icon={icon} size={22} />
        </span>
      )}
    </div>
  );
};

export default InputField;